import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useEffect } from 'react';
import c from 'classnames';
import throttle from 'lodash/throttle';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Surface from '../../../Surface';
import s from './ModalBody.scss';
/**
 * The body of a modal that should rest within an {@link ModalRoot} component. This provides sizing logic for
 * full screening the modal and a {@link Surface} for standard styling.
 */ const ModalBody = (_param)=>{
    var { isFullscreen, children, surfaceType, className } = _param, rest = _object_without_properties(_param, [
        "isFullscreen",
        "children",
        "surfaceType",
        "className"
    ]);
    useEffect(()=>{
        const updateVhUnitVar = ()=>{
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        const updateVhUnitVarThrottled = throttle(updateVhUnitVar, 250);
        updateVhUnitVar();
        window.addEventListener('resize', updateVhUnitVarThrottled);
        return ()=>window.removeEventListener('resize', updateVhUnitVarThrottled);
    }, []);
    return /*#__PURE__*/ React.createElement(Surface, _object_spread({
        tag: Section,
        type: surfaceType,
        className: c(s['root'], isFullscreen && s['fullscreen'], className)
    }, rest), children);
};
ModalBody.displayName = 'ModalBody';
export default ModalBody;

//# sourceMappingURL=ModalBody.js.map